import axios from "axios";
import { API_FORGOT_PASSWORD } from "./URLConstants";


// helper to download blob responses as files
export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export const callForgotpassword = async(email) => {

    const obj ={
                    "email": email
               }
    const headers = {'Content-Type': 'application/json'}
    try{
    const resp = await axios.post(API_FORGOT_PASSWORD,obj,headers)
    return resp.data;
  }catch(err){
    if (err.response?.data) {
      return err.response.data;
    }
    return { status_code: err.response?.status || 500, message: err.message || "Something went wrong" };
  }
}